// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Directory } from '../models';
import { ErrorResponse } from '../models';
import { FileCreate } from '../models';
import { FileDiskSpace } from '../models';
import { FileDiskSpaceUpdate } from '../models';
import { FileItem } from '../models';
import { FileList } from '../models';
import { Folder } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * UserFileApi - axios parameter creator
 * @export
 */
export const UserFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete user\'s file.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/user/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create folder.
         * @param {string} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(folder: string, options: any = {}): RequestArgs {
            // verify required parameter 'folder' is not null or undefined
            if (folder === null || folder === undefined) {
                throw new RequiredError('folder','Required parameter folder was null or undefined when calling createFolder.');
            }
            const localVarPath = `/v1/user/folder/create`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete folder.
         * @param {string} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folder: string, options: any = {}): RequestArgs {
            // verify required parameter 'folder' is not null or undefined
            if (folder === null || folder === undefined) {
                throw new RequiredError('folder','Required parameter folder was null or undefined when calling deleteFolder.');
            }
            const localVarPath = `/v1/user/folder/delete`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user\'s directory.
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directory(folder?: string, options: any = {}): RequestArgs {
            const localVarPath = `/v1/user/directory`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user\'s free space on disk (in bytes).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disk(options: any = {}): RequestArgs {
            const localVarPath = `/v1/user/disk`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit file\'s name, description and folder.
         * @param {string} id 
         * @param {FileCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: FileCreate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/user/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit folder.
         * @param {string} folder 
         * @param {string} newFolder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFolder(folder: string, newFolder: string, options: any = {}): RequestArgs {
            // verify required parameter 'folder' is not null or undefined
            if (folder === null || folder === undefined) {
                throw new RequiredError('folder','Required parameter folder was null or undefined when calling editFolder.');
            }
            // verify required parameter 'newFolder' is not null or undefined
            if (newFolder === null || newFolder === undefined) {
                throw new RequiredError('newFolder','Required parameter newFolder was null or undefined when calling editFolder.');
            }
            const localVarPath = `/v1/user/folder/edit`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (newFolder !== undefined) {
                localVarQueryParameter['newFolder'] = newFolder;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * In future it\'s planned to add the possibility to view files to users who have access
         * @summary Get single file.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/user/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user\'s file list by filter.
         * @param {Array<string>} [ids] 
         * @param {string} [name] 
         * @param {string} [folder] 
         * @param {Date} [uploadedAtMin] 
         * @param {Date} [uploadedAtMax] 
         * @param {string} [mimeType] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'name' | 'uploadedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, name?: string, folder?: string, uploadedAtMin?: Date, uploadedAtMax?: Date, mimeType?: string, offset?: number, limit?: number, sort?: 'name' | 'uploadedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            const localVarPath = `/v1/user/files`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (uploadedAtMin !== undefined) {
                localVarQueryParameter['uploadedAtMin'] = (uploadedAtMin as any).toISOString();
            }

            if (uploadedAtMax !== undefined) {
                localVarQueryParameter['uploadedAtMax'] = (uploadedAtMax as any).toISOString();
            }

            if (mimeType !== undefined) {
                localVarQueryParameter['mimeType'] = mimeType;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload user\'s file.
         * @param {string} fileName 
         * @param {any} file 
         * @param {string} [description] 
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(fileName: string, file: any, description?: string, folder?: string, options: any = {}): RequestArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling upload.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling upload.');
            }
            const localVarPath = `/v1/user/file`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (fileName !== undefined) { 
                localVarFormParams.append('fileName', fileName as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (folder !== undefined) { 
                localVarFormParams.append('folder', folder as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get information about user disk.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDisk(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userDisk.');
            }
            const localVarPath = `/v1/user/{id}/disk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user disk space (in bytes).
         * @param {string} id 
         * @param {FileDiskSpaceUpdate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateDisk(id: string, body?: FileDiskSpaceUpdate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userUpdateDisk.');
            }
            const localVarPath = `/v1/user/{id}/disk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserFileApi - functional programming interface
 * @export
 */
export const UserFileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete user\'s file.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration)._delete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create folder.
         * @param {string} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(folder: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).createFolder(folder, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete folder.
         * @param {string} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folder: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).deleteFolder(folder, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get user\'s directory.
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directory(folder?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Directory> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).directory(folder, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get user\'s free space on disk (in bytes).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disk(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDiskSpace> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).disk(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit file\'s name, description and folder.
         * @param {string} id 
         * @param {FileCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: FileCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileItem> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).edit(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit folder.
         * @param {string} folder 
         * @param {string} newFolder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFolder(folder: string, newFolder: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).editFolder(folder, newFolder, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * In future it\'s planned to add the possibility to view files to users who have access
         * @summary Get single file.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileItem> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).get(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get user\'s file list by filter.
         * @param {Array<string>} [ids] 
         * @param {string} [name] 
         * @param {string} [folder] 
         * @param {Date} [uploadedAtMin] 
         * @param {Date} [uploadedAtMax] 
         * @param {string} [mimeType] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'name' | 'uploadedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, name?: string, folder?: string, uploadedAtMin?: Date, uploadedAtMax?: Date, mimeType?: string, offset?: number, limit?: number, sort?: 'name' | 'uploadedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileList> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).list(ids, name, folder, uploadedAtMin, uploadedAtMax, mimeType, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Upload user\'s file.
         * @param {string} fileName 
         * @param {any} file 
         * @param {string} [description] 
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(fileName: string, file: any, description?: string, folder?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileItem> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).upload(fileName, file, description, folder, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get information about user disk.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDisk(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDiskSpace> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).userDisk(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update user disk space (in bytes).
         * @param {string} id 
         * @param {FileDiskSpaceUpdate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateDisk(id: string, body?: FileDiskSpaceUpdate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserFileApiAxiosParamCreator(configuration).userUpdateDisk(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserFileApi - factory interface
 * @export
 */
export const UserFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Delete user\'s file.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any) {
            return UserFileApiFp(configuration)._delete(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Create folder.
         * @param {string} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(folder: string, options?: any) {
            return UserFileApiFp(configuration).createFolder(folder, options)(axios, basePath);
        },
        /**
         * 
         * @summary Delete folder.
         * @param {string} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folder: string, options?: any) {
            return UserFileApiFp(configuration).deleteFolder(folder, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get user\'s directory.
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directory(folder?: string, options?: any) {
            return UserFileApiFp(configuration).directory(folder, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get user\'s free space on disk (in bytes).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disk(options?: any) {
            return UserFileApiFp(configuration).disk(options)(axios, basePath);
        },
        /**
         * 
         * @summary Edit file\'s name, description and folder.
         * @param {string} id 
         * @param {FileCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: FileCreate, options?: any) {
            return UserFileApiFp(configuration).edit(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @summary Edit folder.
         * @param {string} folder 
         * @param {string} newFolder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFolder(folder: string, newFolder: string, options?: any) {
            return UserFileApiFp(configuration).editFolder(folder, newFolder, options)(axios, basePath);
        },
        /**
         * In future it\'s planned to add the possibility to view files to users who have access
         * @summary Get single file.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any) {
            return UserFileApiFp(configuration).get(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get user\'s file list by filter.
         * @param {Array<string>} [ids] 
         * @param {string} [name] 
         * @param {string} [folder] 
         * @param {Date} [uploadedAtMin] 
         * @param {Date} [uploadedAtMax] 
         * @param {string} [mimeType] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'name' | 'uploadedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, name?: string, folder?: string, uploadedAtMin?: Date, uploadedAtMax?: Date, mimeType?: string, offset?: number, limit?: number, sort?: 'name' | 'uploadedAt', order?: 'ASC' | 'DESC', options?: any) {
            return UserFileApiFp(configuration).list(ids, name, folder, uploadedAtMin, uploadedAtMax, mimeType, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * 
         * @summary Upload user\'s file.
         * @param {string} fileName 
         * @param {any} file 
         * @param {string} [description] 
         * @param {string} [folder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(fileName: string, file: any, description?: string, folder?: string, options?: any) {
            return UserFileApiFp(configuration).upload(fileName, file, description, folder, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get information about user disk.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDisk(id: string, options?: any) {
            return UserFileApiFp(configuration).userDisk(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update user disk space (in bytes).
         * @param {string} id 
         * @param {FileDiskSpaceUpdate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateDisk(id: string, body?: FileDiskSpaceUpdate, options?: any) {
            return UserFileApiFp(configuration).userUpdateDisk(id, body, options)(axios, basePath);
        },
    };
};

/**
 * UserFileApi - object-oriented interface
 * @export
 * @class UserFileApi
 * @extends {BaseAPI}
 */
export class UserFileApi extends BaseAPI {
    /**
     * 
     * @summary Delete user\'s file.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public _delete(id: string, options?: any) {
        return UserFileApiFp(this.configuration)._delete(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Create folder.
     * @param {string} folder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public createFolder(folder: string, options?: any) {
        return UserFileApiFp(this.configuration).createFolder(folder, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Delete folder.
     * @param {string} folder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public deleteFolder(folder: string, options?: any) {
        return UserFileApiFp(this.configuration).deleteFolder(folder, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get user\'s directory.
     * @param {string} [folder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public directory(folder?: string, options?: any) {
        return UserFileApiFp(this.configuration).directory(folder, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get user\'s free space on disk (in bytes).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public disk(options?: any) {
        return UserFileApiFp(this.configuration).disk(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Edit file\'s name, description and folder.
     * @param {string} id 
     * @param {FileCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public edit(id: string, body?: FileCreate, options?: any) {
        return UserFileApiFp(this.configuration).edit(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Edit folder.
     * @param {string} folder 
     * @param {string} newFolder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public editFolder(folder: string, newFolder: string, options?: any) {
        return UserFileApiFp(this.configuration).editFolder(folder, newFolder, options)(this.axios, this.basePath);
    }

    /**
     * In future it\'s planned to add the possibility to view files to users who have access
     * @summary Get single file.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public get(id: string, options?: any) {
        return UserFileApiFp(this.configuration).get(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get user\'s file list by filter.
     * @param {Array<string>} [ids] 
     * @param {string} [name] 
     * @param {string} [folder] 
     * @param {Date} [uploadedAtMin] 
     * @param {Date} [uploadedAtMax] 
     * @param {string} [mimeType] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'name' | 'uploadedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public list(ids?: Array<string>, name?: string, folder?: string, uploadedAtMin?: Date, uploadedAtMax?: Date, mimeType?: string, offset?: number, limit?: number, sort?: 'name' | 'uploadedAt', order?: 'ASC' | 'DESC', options?: any) {
        return UserFileApiFp(this.configuration).list(ids, name, folder, uploadedAtMin, uploadedAtMax, mimeType, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Upload user\'s file.
     * @param {string} fileName 
     * @param {any} file 
     * @param {string} [description] 
     * @param {string} [folder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public upload(fileName: string, file: any, description?: string, folder?: string, options?: any) {
        return UserFileApiFp(this.configuration).upload(fileName, file, description, folder, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get information about user disk.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public userDisk(id: string, options?: any) {
        return UserFileApiFp(this.configuration).userDisk(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update user disk space (in bytes).
     * @param {string} id 
     * @param {FileDiskSpaceUpdate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFileApi
     */
    public userUpdateDisk(id: string, body?: FileDiskSpaceUpdate, options?: any) {
        return UserFileApiFp(this.configuration).userUpdateDisk(id, body, options)(this.axios, this.basePath);
    }

}
